import { ContractType } from "../shared/enums/ContractType";
import { HonorariumType } from "../shared/enums/HonorariumType";
import { ContractStatus } from "../shared/enums/ContractStatus";
import { PaymentType } from "../shared/enums/PaymentType";
import { TaxRegime } from "../shared/enums/TaxRegime";
import { PositionType } from "../shared/enums/PositionType";
import { ContractClassification } from "../shared/enums/ContractClassification";
import { AllocationType } from "../shared/enums/AllocationType";
import { BorrowNoteType } from "../shared/enums/BorrowNote";
import { PartnershipType } from "../shared/enums/PartnershipType";
import { TerminationContract } from "./TerminationContract.model";
import { Additive } from "./Additive.model";

export class Contract {
    begin: string;
    end: string;
    kind: ContractType = 0;
    honorarium: HonorariumType = 0;
    totalValue: number;
    totalCostWithBenefits: number;
    paymentType: PaymentType = 0;
    mensalHours: Number;
    soldHourValue: Number;
    hourValue: number;
    hourValueBenefits: number;
    benefits: String;
    partnership: PartnershipType = 0;
    partnershipObs: String;
    contractStatus: ContractStatus = 0;
    companyName: String;
    cnpj: String;
    taxRegime: TaxRegime = 0;
    borrowedNote: BorrowNoteType = 0;
    position: PositionType = 0;
    occupation: Number = 0;
    classification: ContractClassification = 0;
    allocation: AllocationType = 0;
    cep: String;
    address: String;
    number: String;
    complement: String;
    district: String;
    city: String;
    state: String;
    outsideSP: Boolean;
    cpom: Boolean;
    iss: String;
    irrf: String;
    pcc: String;
    customers: any = [];
    generated: Boolean = false;
    active: Boolean;
    customerActive: Boolean;
    termination: TerminationContract = new TerminationContract();
    additivesHistory: Additive[] = new Array<Additive>();
    cnae: String;
    sapServiceCode: String;
    regularizationDate: string;

    loadToEdit(r: any) {
        if(r.begin)
            this.begin = r.begin;

        if(r.end)
            this.end = r.end;

        if (r.kind !== undefined)
            this.kind = parseInt(r.kind);

        this.honorarium = r.honorarium;
        this.totalValue = r.totalValue;
        this.totalCostWithBenefits = r.totalCostWithBenefits;

        if (r.paymentType !== undefined)
            this.paymentType = parseInt(r.paymentType);

        if(r.generated)
            this.generated = r.generated;

        this.mensalHours = r.mensalHours;
        this.soldHourValue = r.soldHourValue;
        this.hourValue = r.hourValue;
        this.hourValueBenefits = r.hourValueBenefits;
        this.benefits = r.benefits;
        // this.position = r.position;
        this.active = r.active;
        this.customerActive = r.customerActive;

        if (r.partnership !== undefined)
            this.partnership = parseInt(r.partnership);

        this.partnershipObs = r.partnershipObs;

        if (r.contractStatus !== undefined) {
            this.contractStatus = parseInt(r.contractStatus);
        }

        this.companyName = r.companyName;
        this.cnpj = r.cnpj;

        if (r.customers)
            for (let c of r.customers) {
                this.customers.push(c);
            }

        if (r.taxRegime !== undefined)
            this.taxRegime = parseInt(r.taxRegime);

        if(r.borrowedNote !== undefined)
            this.borrowedNote = parseInt(r.borrowedNote);

        if(r.position !== undefined)
            this.position = parseInt(r.position);

        if(r.occupation !== undefined)
            this.occupation = parseInt(r.occupation);

        if(r.classification !== undefined)
            this.classification = parseInt(r.classification);

        if(r.allocation !== undefined)
            this.allocation = parseInt(r.allocation);

        if(r.termination)
            this.termination.loadToEdit(r.termination);

        if (r.additivesHistory)
            for (let a of r.additivesHistory) {
                let additive = new Additive();
                additive.populateFromServer(a);
                this.additivesHistory.push(additive);
            }

        if(r.regularizationDate)
            this.regularizationDate = r.regularizationDate;

        this.cep = r.cep;
        this.address = r.address;
        this.number = r.number;
        this.complement = r.complement;
        this.district = r.district;
        this.city = r.city;
        this.state = r.state;
        this.outsideSP = r.outsideSP;
        this.cpom = r.cpom;
        this.iss = r.iss;
        this.irrf = r.irrf;
        this.pcc = r.pcc;
        this.cnae = r.cnae;
        this.sapServiceCode = r.sapServiceCode;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Contract.model.ts